(() => {
  if (customElements.get("pup-set")) return;
  class PupSet extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.busy = false;
      this.messages = this.querySelector("[data-fs-messages]").dataset;
      const data = JSON.parse(this.querySelector("[data-fs-config]").textContent);
      const pair = data.fallback.find(p => [p.human.id,p.pet.id].includes(Number(this.dataset.currentId))) || (data.human?.id && data.pet?.id && [data.human.id,data.pet.id].includes(Number(this.dataset.currentId)) ? {human:data.human,pet:data.pet} : null);
      this.charts = data.charts || {};
      if (!pair) { this.hidden = true; return; }
      this.products = {};
      for (const role of ["human","pet"]) {
        const published = data[role];
        this.products[role] = published && published.id ? published : pair[role];
        if (Number(data.current.id) === Number(this.products[role].id)) this.products[role] = data.current;
        this.renderProduct(role);
      }
      this.button = this.querySelector("[data-add]");
      this.status = this.querySelector("[data-status]");
      this.dialog = this.querySelector("dialog");
      const options = {signal:this.controller.signal};
      this.addEventListener("change",e => { if (e.target.matches("[data-size]")) this.update(); },options);
      this.addEventListener("click",e => {
        const chart = e.target.closest("[data-chart-role],[data-chart-current]");
        if (chart) {
          const role = chart.hasAttribute("data-chart-current") ? (Number(this.products.human.id) === Number(this.dataset.currentId) ? "human" : "pet") : chart.dataset.chartRole;
          this.openChart(role,chart);
        }
        if (e.target.closest("[data-chart-close]")) this.dialog.close();
        if (e.target.closest("[data-add]")) this.addSet();
      },options);
      this.dialog.addEventListener("click",e => {
        if (e.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) this.dialog.close();
      },options);
      this.dialog.addEventListener("close",() => { document.documentElement.classList.remove("fs-chart-open"); this.chartTrigger?.focus(); },options);
      const area = this.closest("product-info") || this.parentElement;
      area.addEventListener("change",e => {
        if (e.target.closest("pup-set")) return;
        queueMicrotask(() => this.syncCurrentSize());
      },options);
      this.syncCurrentSize();
      this.update();
      const existing = area.querySelector(".frenchie-shop-size-chart");
      if (existing) existing.hidden = true;
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove("fs-chart-open");
      }
      this.initialized = false;
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || "en",{style:"currency",currency:this.dataset.currency || "USD"}).format(cents/100);
    }
    renderProduct(role) {
      const product = this.products[role];
      const item = this.querySelector('[data-role="'+role+'"]');
      item.querySelectorAll("[data-product-link]").forEach(a => a.href = (window.Shopify?.routes?.root || "/") + "products/" + product.handle);
      item.querySelector("[data-product-title]").textContent = product.title;
      const image = item.querySelector("[data-product-image]");
      const src = typeof product.featured_image === "string" ? product.featured_image : product.featured_image?.src;
      if (src) { image.src = src; image.alt = product.title; } else image.hidden = true;
      const select = item.querySelector("select");
      for (const variant of product.variants || []) {
        const option = document.createElement("option");
        option.value = String(variant.id);
        option.textContent = variant.title + (product.available && !variant.available ? " — "+this.messages.soldOut : "");
        option.disabled = !variant.available;
        select.append(option);
      }
      item.querySelector("[data-product-price]").textContent = this.money(product.variants?.[0]?.price || 0);
    }
    selected(role) {
      const value = this.querySelector('[data-size="'+role+'"]').value;
      return this.products[role].variants.find(v => String(v.id) === value);
    }
    syncCurrentSize() {
      const input = document.getElementById("product-form-"+this.dataset.sectionId)?.querySelector('[name="id"]');
      if (!input) return;
      const role = Number(this.products.human.id) === Number(this.dataset.currentId) ? "human" : "pet";
      const select = this.querySelector('[data-size="'+role+'"]');
      if ([...select.options].some(o => o.value === input.value && !o.disabled)) select.value = input.value;
      this.update();
    }
    update() {
      if (!this.button) return;
      let total = 0;
      let complete = true;
      let available = true;
      for (const role of ["human","pet"]) {
        const variant = this.selected(role);
        complete = complete && Boolean(variant);
        available = available && Boolean(this.products[role].available && variant?.available);
        const price = variant?.price ?? this.products[role].variants?.[0]?.price ?? 0;
        this.querySelector('[data-role="'+role+'"] [data-product-price]').textContent = this.money(price);
        total += price;
      }
      this.querySelector("[data-total]").textContent = this.money(total);
      this.button.disabled = this.busy || !complete || !available;
      if (!this.busy && !this.products.human.available || !this.busy && !this.products.pet.available) this.status.textContent = this.messages.unavailable;
      else if (!this.busy && this.status.textContent === this.messages.unavailable) this.status.textContent = "";
    }
    openChart(role,trigger) {
      const template = document.createElement("template");
      template.innerHTML = this.products[role].description || "";
      let chart = template.content.querySelector(".frenchie-shop-size-chart");
      if (this.charts[role]) { const verified = document.createElement("div"); verified.innerHTML = this.charts[role]; if (verified.querySelector("table,img")) chart = verified; }
      if (!chart) return;
      chart.querySelectorAll("summary,script,iframe,style,link").forEach(node => node.remove());
      chart.querySelectorAll("*").forEach(node => [...node.attributes].filter(a => a.name.startsWith("on") || a.name === "style").forEach(a => node.removeAttribute(a.name)));
      const content = this.querySelector("[data-chart-content]");
      content.replaceChildren(...chart.childNodes);
      this.querySelector("[data-chart-title]").textContent = role === "human" ? "Human Size Chart" : "Dog Size Chart";
      this.chartTrigger = trigger;
      this.dialog.showModal();
      document.documentElement.classList.add("fs-chart-open");
      this.querySelector("[data-chart-close]").focus();
    }
    async addSet() {
      if (this.busy) return;
      const human = this.selected("human"), pet = this.selected("pet");
      if (!human || !pet) { this.status.textContent = this.messages.chooseBoth; return; }
      if (!this.products.human.available || !this.products.pet.available || !human.available || !pet.available) {
        this.status.textContent = this.messages.unavailable; return;
      }
      this.busy = true;
      this.button.textContent = this.messages.adding;
      this.status.textContent = "";
      this.update();
      try {
        const response = await fetch((window.Shopify?.routes?.root || "/")+"cart/add.js",{
          method:"POST",
          credentials:"same-origin",
          headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify({items:[{id:human.id,quantity:1},{id:pet.id,quantity:1}]})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) throw new Error(typeof result.description === "string" ? result.description : this.messages.error);
        this.status.textContent = this.messages.added;
        this.querySelector("[data-view-cart]").hidden = false;
        window.location.assign(this.dataset.cartUrl || (window.Shopify?.routes?.root || "/")+"cart");
      } catch (error) {
        this.status.textContent = error.message || this.messages.error;
      } finally {
        this.busy = false;
        this.button.textContent = this.messages.add;
        this.update();
      }
    }
  }
  customElements.define("pup-set",PupSet);
})();
